export default class TableDeleteMultipleRowsMixin {


  //  abstract methods
  //
  //  get lang();
  //  get table_element();
  //  get wrapper_block()
  // _submitSelectedCheckboxesForm(form, url);

  get table_selector() {
    return this._selectors.table;
  }

  get _selectors() {
    return {
      parent_form: '.list_form',
      table: 'table.list',
      select_all_rows: '.select_all_rows',
      select_one_row: '.select_one_row',
      delete_selected_rows: '.delete_selected'
    };
  }

  get rows_select_checkboxes() {
    return $(this.table_element).find(this._selectors.select_one_row);
  }

  get select_all_checkbox() {
    return $(this.table_element).find(this._selectors.select_all_rows);
  }

  get delete_selected_button() {
    return this.wrapper_block.find(this._selectors.delete_selected_rows);
  }

  get selected_rows() {
    return $(this.table_element).find(this._selectors.select_one_row + ':checked');
  }

  get select_checkboxes_form() {
    return this.wrapper_block.find(this._selectors.parent_form);
  }

  _initSelectAllCheckbox() {

    var table = this;

    this.select_all_checkbox.click(function () {
      table.rows_select_checkboxes.attr('checked', this.checked);
    });
  }

  _initDeleteSelectedRowsButton() {

    var table = this;

    this.delete_selected_button.click(function (event) {

      if (!table._hasSelectedRows()) {
        alert(table.lang.getText('select_rows'));
        return false;
      }

      if (!confirm(table.lang.getText('confirm_few_rows_delete'))) {
        return false;
      }

      event.preventDefault();
      table._submitSelectedCheckboxesForm(table.select_checkboxes_form, $(this).attr('href'));
    });
  };

  _hasSelectedRows() {
    return this.selected_rows.length > 0;
  };
}


/** WEBPACK FOOTER **
 ** ./src/common/table/delete_multiple_rows_mixin.js
 **/